<template>
    <div
        v-if="!props.success"
        class="w-full pt-4 flex flex-col space-y-6 items-center justify-between lg:flex-row lg:space-y-0 lg:pt-8"
    >
        <div>
            <h3 class="font-extrabold text-slate-700">Increase your conversion!</h3>
            <p class="text-xs text-slate-500">
                Automatically send a follow-up message to remind your customers to convert.
                <br />
                We&apos;ve found this reliably boosts conversion to the original message!
            </p>
        </div>

        <div class="relative grid place-items-center">
            <vx-button @click="emit('continue')" type="button" size="lg" color="info">
                Add Follow-Up <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
            </vx-button>
        </div>
    </div>
    <div v-else class="pt-8 pb-6 text-center lg:pt-12">
        <vx-badge :borders="true" class="my-2">
            <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
            Follow-Up Queued
        </vx-badge>
        <p class="mt-4 text-lg font-normal text-slate-600">Your message is queued for delivery.</p>
    </div>
</template>

<script setup>
import { faCirclePlus, faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBadge, VxButton } from '@voxie/frontend-components';

const emit = defineEmits(['continue']);
const props = defineProps({
    success: {
        type: Boolean,
    },
});
</script>
